const Cancel = function () {
  this.addUser.resetAddUserModal()
}

export default Cancel
